module.exports = __webpack_public_path__ + "media/images/cutout-effect-d1dcda196a982461a88646cd06004db8.svg";